import { render } from "./RestaurantsDropDown.vue?vue&type=template&id=a69d89a6&scoped=true&ts=true"
import script from "./RestaurantsDropDown.vue?vue&type=script&lang=ts"
export * from "./RestaurantsDropDown.vue?vue&type=script&lang=ts"

import "./RestaurantsDropDown.vue?vue&type=style&index=0&id=a69d89a6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a69d89a6"]])

export default __exports__